import { usePreferences } from "hooks/use-preferences"
import { produce } from "immer"
import { createContext, useMemo, useReducer } from "react"
import { useModelPreferencesValidation } from "../hooks/preference-validation/use-model-preferences-validation"

export const ModelContext = createContext()

const PREFERENCE_SUBTYPE = "model"

const DEFAULT_STATE = {
  modelId: null,
}

const PREFERENCE_FIELDS = [
  "modelId",
]

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
      case "setModelId":
        draft.modelId = action.modelId
        break
    }
  })
}

function setPreferences(preferences) {
  return {
    type: "setPreferences",
    preferences,
  }
}

function setModelId(modelId) {
  return {
    type: "setModelId",
    modelId,
  }
}

export function useModelContext() {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)
  const setPreferenceValidationOptions = useModelPreferencesValidation()

  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
    { setPreferenceValidationOptions },
  )

  const contextUpdaters = useMemo(() => ({
    setModelId: (...args) => dispatch(setModelId(...args)),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return [ModelContext, contextValue]
}
